import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { MenuDotsVertical } from "components/icons/MenuDotsVertical";

type FinallyImportActionsMenuProps = {
  onRevert: () => void;
};

export const FinallyImportActionsMenu = ({
  onRevert,
}: FinallyImportActionsMenuProps) => (
  <Dropdown.Root>
    <Dropdown.Trigger asChild>
      <div>
        <Button
          type="button"
          customType="ghost_icon"
          size="small"
          aria-label="Finally import options"
        >
          <span className="t-flex t-text-neutral-40">
            <MenuDotsVertical />
          </span>
        </Button>
      </div>
    </Dropdown.Trigger>
    <Dropdown.Portal>
      <Dropdown.Content align="end" sideOffset={4}>
        <Dropdown.Item textValue="Revert" onSelect={onRevert} type="danger">
          Revert
        </Dropdown.Item>
      </Dropdown.Content>
    </Dropdown.Portal>
  </Dropdown.Root>
);
